import { useEffect, useMemo, useState } from 'react';
import { useAtomValue } from 'jotai';
import { getMyVotes, isSavedVote, votesAtom } from '../services/vote.service';

/**
 * The voteKeys (team + room) the signed-in user has scored: what the server knew when the page opened, plus every
 * vote saved or loaded since, so a team gets its check mark the moment the vote is saved.
 */
export const useMyVotes = (hackathonId: string | undefined) => {
    const [loaded, setLoaded] = useState<string[]>([]);
    useEffect(() => {
        if (!hackathonId) {
            return;
        }
        getMyVotes(hackathonId).then(setLoaded, err => console.error(err));
    }, [hackathonId]);

    const votes = useAtomValue(votesAtom);
    return useMemo(() => {
        const scored = new Set(loaded);
        Object.entries(votes).forEach(([key, vote]) => {
            if (isSavedVote(vote)) {
                scored.add(key);
            }
        });
        return scored;
    }, [loaded, votes]);
}
